//var barba = require('@barba/core');
//var css = require('@barba/css');
import Swiper from 'swiper';
import Marquee3k from 'marquee3000';
import SwiperCore, { Pagination, Navigation, Thumbs, EffectFade, Autoplay } from 'swiper/core';
SwiperCore.use([Pagination, Navigation, Thumbs, EffectFade, Autoplay]);
//import Cookies from 'js-cookie';
import TinyVector from './tinyvector.js'; 
import Random from './random.js'
/*!

 * Random JavaScript Library v1.5.1
 * Jeremy Zevin
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 * Date: 4/22/17
 *
 */
/*!
 * tinyvector 2D JavaScript Lib
 * Jeremy Zevin
 *
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 *
 * Date: 4/22/17
 *
 */

document.addEventListener('scroll', function(){
  // This grabs the percentage the page is scrolled
  var h = document.documentElement,
      b = document.body,
      st = 'scrollTop',
      sh = 'scrollHeight';
  var scrollingBar = document.getElementById('scrolling');
  var percent = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
  scrolling.style.width = percent + '%';
});

window.addEventListener('load', function(event) {
  Marquee3k.init();
  alert('test')
});


var EmojiCache = /** @class */ (function () {
  function EmojiCache(app) {
      var _this = this;
      this.rnd = app.rnd;
      this.ctxs = [];
      this.emojis = ['💾', '💩', '💥', '🦜', '🤖', '💻'];
      this.ctxSize = 128;
      this.emojis.forEach(function (e) {
          var ctx = document.createElement('canvas').getContext('2d');
          ctx.canvas.id = e;
          ctx.canvas.width = ctx.canvas.height = _this.ctxSize;
          _this.ctxs.push(ctx);
          //document.body.appendChild(ctx.canvas);
      });
      this.draw();
  }
  EmojiCache.prototype.draw = function () {
      var _this = this;
      this.ctxs.forEach(function (ctx, i) {
          ctx.save();
          ctx.fillStyle = '#333';
          ctx.textBaseline = "top";
          ctx.font = _this.ctxSize + 'px sans-serif';
          ctx.fillText(_this.emojis[i], 0, 0);
          ctx.restore();
      });
  };
  return EmojiCache;
}());
var Firework = /** @class */ (function () {
  function Firework(app) {
      this.app = app;
      this.rnd = app.rnd;
      this.bursts = [];
      this.reset();
  }
  Firework.prototype.reset = function () {
      this.color = "hsl(".concat(this.rnd.int(360), ",90%,50%)");
      this.alive = true;
      this.bursting = false;
      this.pos = new Vec(this.rnd.int(0, this.app.w), this.app.h + 40);
      this.vel = new Vec(0, -this.rnd.real(16.0, this.app.h / 40));
      this.acc = new Vec(0, 0);
      this.size = this.rnd.real(0.06125, 0.75);
      this.emoji = this.rnd.pick(this.app.emojis);
      this.emoji = this.rnd.pick(this.app.emojiCache.ctxs);
      this.offset = 128 * this.size;
  };
  Firework.prototype.applyForce = function (f) {
      this.vel.add(f);
  };
  Firework.prototype.update = function () {
      this.applyForce(this.app.forces.gravity);
      this.vel.add(this.acc);
      this.pos.add(this.vel);
      if (this.vel.y > 1) {
          this.bursting = true;
          var maxBursts = Math.floor(this.app.w / 4);
          var numBursts = this.rnd.chance(5) ? this.rnd.int(100, maxBursts) : this.rnd.int(20, 80);
          for (var i = 1; i < numBursts; i++) {
              this.bursts.push(new Burst(this.pos, this));
          }
      }
  };
  Firework.prototype.draw = function () {
      var _this = this;
      var ctx = this.app.ctx;
      if (!this.bursting) {
          this.update();
          ctx.save();
          //ctx.fillStyle = this.color;
          //ctx.font = `${this.size}em sans-serif`;
          //ctx.fillText(this.emoji,this.pos.x,this.pos.y);
          //ctx.fillRect(this.pos.x, this.pos.y, this.size, this.size);
          //console.log(this.emoji)
          ctx.translate(this.pos.x - (this.offset), this.pos.y - (this.offset));
          ctx.scale(this.size, this.size);
          ctx.drawImage(this.emoji.canvas, 0, 0);
          ctx.restore();
      }
      else {
          this.bursts.forEach(function (burst) {
              if (!burst.alive) {
                  without(_this.bursts, burst);
                  if (_this.bursts.length === 0) {
                      _this.alive = false;
                  }
              }
              burst.draw();
          });
      }
  };
  return Firework;
}());
var Burst = /** @class */ (function () {
  function Burst(origin, firework) {
      this.firework = firework;
      this.app = firework.app;
      this.pos = origin.clone();
      this.rnd = firework.rnd;
      this.lifespan = this.rnd.int(5, 50);
      this.vel = new Vec(this.rnd.real(-8.0, 8.0), this.rnd.real(-8.0, 8.0));
      this.acc = new Vec(0, 0);
      this.color = this.firework.color;
      this.size = this.firework.size / 2;
      var sparkle = 1; //this.rnd.chance(20) ? 2 : 1;
      this.sizeStep = this.size / (this.lifespan / sparkle);
      this.alive = true;
      this.rotate = this.rnd.real(0, Math.PI * 2);
      this.offset = this.firework.offset / 2;
      this.rotateInc = this.rnd.real(-1.45, 1.45);
  }
  Burst.prototype.applyForce = function (f) {
      this.vel.add(f);
  };
  Burst.prototype.update = function () {
      this.applyForce(this.app.forces.gravity);
      this.vel.add(this.acc);
      this.pos.add(this.vel);
      this.size -= this.sizeStep;
      this.rotate += this.rotateInc;
  };
  Burst.prototype.draw = function () {
      var ctx = this.app.ctx;
      this.update();
      ctx.save();
      ctx.translate(this.pos.x - this.offset / 2, this.pos.y - this.offset / 2);
      ctx.rotate(this.rotate);
      ctx.scale(this.size, this.size);
      ctx.drawImage(this.firework.emoji.canvas, 0, 0);
      ctx.restore();
      this.lifespan--;
      if (this.lifespan <= 0) {
          this.alive = false;
      }
  };
  return Burst;
}());
var App = /** @class */ (function () {
  function App() {
      var _this = this;
      this.ctx = document.getElementById('cnv').getContext('2d');
      this.sizeCanvas();
      this.initEvents();
      this.rnd = new Random();
      this.emojiCache = new EmojiCache(this);
      this.fireworks = [];
      this.forces = {
          gravity: new Vec(0, 0.25)
      };
      this.emojis = ['😊', '🍕', '💩', '☘', '👀', '🐟', '💥', '⚡️', '🍉', '🍟', '⚽️'];
      window.requestAnimationFrame(function (t) { _this.draw(t); });
      log(this);
  }
  App.prototype.sizeCanvas = function () {
      this.w = this.ctx.canvas.width = window.innerWidth;
      this.h = this.ctx.canvas.height = window.innerHeight;
  };
  App.prototype.clearIt = function () {
      //this.ctx.clearRect(0,0,this.w,this.h);
      this.ctx.save();
      this.ctx.fillStyle = 'hsla(220,60%,10%,0.12)';
      this.ctx.fillRect(0, 0, this.w, this.h);
      this.ctx.restore();
  };
  App.prototype.draw = function (t) {
      var _this = this;
      //this.clearIt();
      window.requestAnimationFrame(function (t) { _this.draw(t); });
      if (this.rnd.chance(this.w / 120)) {
          this.fireworks.push(new Firework(this));
      }
      this.fireworks.forEach(function (f) {
          if (!f.alive) {
              without(_this.fireworks, f);
          }
          //log(this.fireworks.length)
          f.draw();
      });
  };
  App.prototype.initEvents = function () {
      var _this = this;
      window.onresize = function (e) { _this.sizeCanvas(e); };
  };
  return App;
}());
var foo = 'dsdsa';
var log = console.log.bind(console);
var Vec = TinyVector;
document.addEventListener('DOMContentLoaded', function () {
  var app = new App();
});
function without(arr, el) {
  arr.splice(arr.indexOf(el), 1);
}







        // JavaScript to be fired on all pages

        function all() {}



        all();






/*
        barba.use(css);
        barba.init({
          preventRunning: true,
          timeout: 200000,


          transitions: [

            {

              beforeLeave: function (data) {

              },

              
              beforeEnter: function (data) {
                document.querySelector('.header__trigger').classList.remove('active');
                document.querySelector('.theme-header').classList.remove('active-friends');
                document.querySelector('.friends__trigger').classList.remove('is-active');
              //  document.querySelector('.friends-marquee').classList.remove('active');
                document.querySelector('.swiper-container-free-mode').classList.remove('active');
                document.querySelector('.checkered-bg').classList.remove('active');
                document.querySelector('.header__menu').classList.remove('active');

                  var swiperOptions = {
                    loop: true,
                    autoplay: {
                      disableOnInteraction: false,
                      delay: 1,
                    },
                    slidesPerView: 'auto',
                    speed: 5000,
                    grabCursor: true,
                  };

                  var swiperfree = new Swiper(".swiper-container-free-mode", swiperOptions);


                  swiperfree.destroy();


                var nav_collection_emoji = document.querySelector('.theme-header [href="https://possi.kitchen/collections/"] span').classList[0];
                var span_collections = document.createElement('span');
                span_collections.className = nav_collection_emoji + ' entered';
                var listItems_collections = document.querySelectorAll('.container [href="https://possi.kitchen/collections/"]');
                Array.from(listItems_collections).forEach(function (item) {
                  item.prepend(span_collections.cloneNode(true));
                });

                var nav_components_emoji = document.querySelector('.theme-header [href="https://possi.kitchen/components/"] span').classList[0];
                var span_components = document.createElement('span');
                span_components.className = nav_components_emoji + ' entered';
                var listItems_components = document.querySelectorAll('.container [href="https://possi.kitchen/components/"]');
                Array.from(listItems_components).forEach(function (item) {
                  item.prepend(span_components.cloneNode(true));
                });

                var nav_material_emoji = document.querySelector('.theme-header [href="https://possi.kitchen/materials/"] span').classList[0];
                var span_materials = document.createElement('span');
                span_materials.className = nav_material_emoji + ' entered';
                var listItems_materials = document.querySelectorAll('.container [href="https://possi.kitchen/materials/"]');
                Array.from(listItems_materials).forEach(function (item) {
                  item.prepend(span_materials.cloneNode(true));
                });


                var nav_vision_emoji = document.querySelector('.theme-header [href="https://possi.kitchen/vision/"] span').classList[0];
                var span_vision = document.createElement('span');
                span_vision.className = nav_vision_emoji + ' entered';
                var listItems_vision = document.querySelectorAll('.container [href="https://possi.kitchen/vision"]');
                Array.from(listItems_vision).forEach(function (item) {
                  item.prepend(span_vision.cloneNode(true));
                });


                (function () {
                  var current = location.pathname;
                  if (current === "") return;
                  var menuItems = document.querySelectorAll('.nav__item__fetch');
                  if (current === '/' || current === '' ) {
                    for (var i = 0, len = menuItems.length; i < len; i++) {
                      menuItems[i].classList.remove('is-active');
                    }
                  }

                  else {
                    for (var i = 0, len = menuItems.length; i < len; i++) {
                      menuItems[i].classList.remove('is-active');
                      if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
                        menuItems[i].className += " is-active";
                      }
                    }
                  }

                })();



                (function () {
                  var current = location.pathname;
                  if (current === "") return;
                  var menuItems = document.querySelectorAll('.custom-categories a');
                  if (current === '/' || current === '' ) {
                    for (var i = 0, len = menuItems.length; i < len; i++) {
                      menuItems[i].classList.remove('is-active');
                    }
                  }

                  else {
                    for (var i = 0, len = menuItems.length; i < len; i++) {
                      menuItems[i].classList.remove('is-active');
                      if (menuItems[i].getAttribute("href").indexOf(current) !== -1) {
                        menuItems[i].className += " is-active";
                      }
                    }
                  }

                })();




               // Marquee3k.pauseAll();

                all();







              },
              afterEnter: function (data) {

                if(document.querySelector('#macy-container') != null) {
                  var macy = Macy({
                    container: '#macy-container',
                    waitForImages: true,
                    margin: 32,
                    columns: 3,
                    breakAt: {
                      1200: 3,
                      940: 1,
                      520: 1,
                      400: 1
                    }
                  });
                  macy.reInit();
                }
              },


              leave: function (data) {
              },
              enter: function (data) {
              },
            },
          ],
        });
*/










/*
        barba.hooks.afterLeave((data) => {




          const remove_after = data.next.html.indexOf('" id="body"'),
              result =  data.next.html.substring(0, remove_after),
              result_2 = result.substring(result.indexOf("<body class=") + 13);
          document.body.setAttribute("class", result_2);

          if (!match || !match[1]) {
            // If no body class, remove it
            document.body.setAttribute("class", "");
          } else {
            // Set the new body class
            document.body.setAttribute("class", result);
          }

          // Set <body> classes for "next" page
          var nextHtml = data.next.html;
          var response = nextHtml.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', nextHtml);
          var bodyClasses = $(response).filter('notbody').attr('class');
          $("body").attr("class", bodyClasses);


        });

        barba.hooks.afterEnter((data) => {


        });



        barba.hooks.enter(() => {


          window.scrollTo(0, 0);
        });

*/















